module.exports = __webpack_public_path__ + "media/images/front/common/icon_new-7c7207d08cdb03b60e14727343b6474e.svg";